import lodash from "lodash";
import { useCallback } from "react";
import HBModel from "../../HBModal";
import PinCreator from "./index";

export default function ModalWrapper(props) {
  const { visible, onOk, onCloseCreator } = props;
  const params = [
    "pinId",
    "targetBoardId",
    "targetAvatarUrl",
    "suggestTags",
    "selectable",
    "closeAfterDone",
    "closeWaitSeconds",
  ];
  const creatorParams = lodash.pick(props, params);
  const _onCloseCreator = useCallback(
    (pin, board) => {
      onOk && onOk(pin, board);
      onCloseCreator && onCloseCreator(pin, board);
    },
    [onOk, onCloseCreator]
  );

  return (
    <HBModel
      {...lodash.omit(props, params)}
      visible={visible}
      footer={null}
      bodyStyle={{ padding: 0 }}
      width={719}
      destroyOnClose
    >
      <div
        data-dialog-title={`采集弹框`}
        data-gd-expose="dialog_expose"
        style={{ height: 540 }}
      >
        {!!visible && (
          <PinCreator {...creatorParams} onCloseCreator={_onCloseCreator} />
        )}
      </div>
    </HBModel>
  );
}
